import { MapsAPILoader } from '@agm/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from '../extensions';

@Injectable()
export class GoogleMapsService {
    public googleObject = null;

    constructor(private mapsAPILoader: MapsAPILoader) {
    }

    public getGoogle() {
        return new Promise((resolve, reject) => {
            if (this.googleObject) {
                resolve(this.googleObject);
            }
            this.mapsAPILoader.load().then(() => {
                this.googleObject = google;
                resolve(this.googleObject);
            });
        });
    }

    public travelTime(waypoints: any[], callback: (response) => void, errorCallback?: (error) => void) {
        if (!waypoints || !waypoints.length || waypoints.length === 1) {
            return {
                distance: 0,
                time: 0
            };
        }

        let origins = waypoints.slice(0, waypoints.length - 1);
        let destinations = waypoints.slice(1, waypoints.length);

        //this.mapsAPILoader.load().then(() => {
        this.getGoogle().then(() => {
            let service = new google.maps.DistanceMatrixService;
            service.getDistanceMatrix(
                {
                    origins: origins,
                    destinations: destinations,
                    travelMode: google.maps.TravelMode.DRIVING,
                    unitSystem: google.maps.UnitSystem.IMPERIAL,
                }, (response, status) => {
                    if (status.toString() === 'OK') {
                        callback(response);
                    } else {
                        if (errorCallback) {
                            errorCallback(response);
                            return;
                        }
                        //alert('An error occurred when calculating travel time!');
                    }
                });
        });
    }

    public getFullRoute(items) {
        let origin = items[0];
        let destination = items[items.length - 1];
        let directions = {
            origin: {
                lat: origin.address.lat || origin.lat,
                lng: origin.address.lng || origin.lng
            },
            destination: {
                lat: destination.address.lat || destination.lat,
                lng: destination.address.lng || destination.lng
            },
            waypoints: [],
            options: {
                suppressMarkers: true,
                draggable: false,
                // markerOptions: {
                //     icon: ''
                // }
            }
        };

        return Observable.create((observer) => {
            try {
                this.getGoogle().then(() => {
                    items.forEach((x, index) => {
                        if (index !== 0 && index !== items.length - 1) {
                            let latlng = new google.maps.LatLng(x.address.lat || x.lat, x.address.lng || x.lng);
                            directions.waypoints.push({location: latlng, stopover: true});
                            //this.directions.waypoints.push({location: x.item.address.address || x.item.address, stopover: true});
                        }
                    });

                    observer.next(directions);
                    observer.complete();
                });
            } catch (error) {
                observer.error(error);
            }
        });
    }

    public getDirection(attractions: any[], travelMode: TravelMode, callback: (response) => void, errorCallback?: (error) => void) {
        if (!attractions || !attractions.length || attractions.length === 1) {
            return errorCallback ? errorCallback('check your parameters!') : alert('check your parameters!');
        }

        //this.mapsAPILoader.load().then(() => {
        this.getGoogle().then(() => {
            let origin = null;
            let destination = null;
            let wypts = [];
            attractions.forEach((x, index) => {
                let latlng = new google.maps.LatLng(x.item.address.lat || x.item.lat, x.item.address.lng || x.item.lng);
                if (index === 0) {
                    origin = latlng;
                } else if (index === attractions.length - 1) {
                    destination = latlng;
                } else {
                    wypts.push({location: latlng, stopover: true});
                }
            });

            let directionsService = new google.maps.DirectionsService;

            directionsService.route({
                origin: origin,
                destination: destination,
                waypoints: wypts, //[{location: '1031 Cermak Rd, Chicago, IL ', stopover: true}],
                optimizeWaypoints: false,
                travelMode: google.maps.TravelMode[travelMode],
                // travelMode: google.maps.TravelMode.DRIVING,
            }, function (response, status) {
                if (status.toString().toLowerCase() === 'ok') {
                    callback(response.routes[0]);
                } else {
                    if (errorCallback) {
                        errorCallback(status);
                        return;
                    }
                    //alert('An error occurred when calculating travel time!');
                }
            });
        });
    }

    public fitBounds(items) {
        return Observable.create((observer) => {
            try {
                if (!items || !items.length) {
                    observer.complete();
                }

                this.getGoogle().then(() => {
                    let latLngBounds = new google.maps.LatLngBounds();

                    items.forEach(x => {
                        if (!isNullOrUndefined(x.address.lat) && !isNullOrUndefined(x.address.lng)) {
                            latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
                        }
                    });
                    observer.next(latLngBounds);
                    observer.complete();
                });

            } catch (error) {
                observer.error(error);
            }
        });
    }

    public getUserLocation(): Promise<any> {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                console.log(`lat: ${lat}, lng: ${lng}`);

                resolve({lat: 27.674044, lng: -82.175407});
                //resolve({ lat, lng });
            }, (error) => {
                console.log('ERROR(' + error.code + '): ' + error.message);
                alert('Unable to retrieve your location!' + 'ERROR(' + error.code + '): ' + error.message);
                reject(error);
            });
        });
    }

    public getUserGPSLocation(): Observable<any> {
        return Observable.create((observer) => {
            try {
                navigator.geolocation.getCurrentPosition((position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    console.log(`lat: ${lat}, lng: ${lng}`);

                    observer.next({ lat, lng });
                    observer.complete();
                }, (error) => {
                    console.log('ERROR(' + error.code + '): ' + error.message);
                    alert('Unable to retrieve your location!' + 'ERROR(' + error.code + '): ' + error.message);
                    observer.error(error);
                });
            } catch (error) {
                console.log('ERROR(' + error.code + '): ' + error.message);
                alert('Unable to retrieve your location');
                observer.error(error);
            }
        });
    }
}

export enum TravelMode {
    DRIVING = 'DRIVING',
    BICYCLING = 'BICYCLING',
    WALKING = 'WALKING',
    TRANSIT = 'TRANSIT',
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/services/google.maps.service.ts